import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, Leaf } from "lucide-react";
import { SITE } from "../data/site";

const LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "manifesto", label: "Approach" },
  { id: "fees", label: "Fees" },
  { id: "reviews", label: "Reviews" },
  { id: "contact", label: "Contact" },
];

export const Navbar = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "glass py-3" : "py-5"}`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <button data-testid="nav-brand-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3 group">
          <span className="grid place-items-center w-9 h-9 rounded-full bg-[#3A7D32] text-[#F2F8E8] group-hover:rotate-12 transition-transform duration-500">
            <Leaf size={17} />
          </span>
          <span className="text-left leading-tight">
            <span className="block display-serif font-bold text-xl sm:text-2xl tracking-[0.14em] text-[#111111]">SERENE MIND PLACE</span>
            <span className="overline text-[0.6rem]">Jubilee Hills · Open</span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-link-${l.id}`} onClick={() => go(l.id)}
              className="text-sm text-[#55703F] hover:text-[#3A7D32] transition-colors relative after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-[#3A7D32] hover:after:w-full after:transition-all after:duration-300">
              {l.label}
            </button>
          ))}
          <button data-testid="nav-book-button" onClick={onBook}
            className="rounded-full px-5 py-2.5 text-sm bg-[#3A7D32] text-[#F2F8E8] hover:bg-[#20301A] hover:scale-[1.03] transition-all duration-300">
            Book Consultation
          </button>
        </div>

        <button className="md:hidden text-[#3A7D32]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }}
          className="md:hidden bg-[#FFEFDF] border-t border-[#FFC9A0] px-5 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="text-left text-[#3A7D32] text-base">{l.label}</button>
          ))}
          <button onClick={() => { setOpen(false); onBook(); }} className="rounded-full px-5 py-3 bg-[#3A7D32] text-[#F2F8E8] text-sm">Book Consultation</button>
        </motion.div>
      )}
    </motion.header>
  );
};
